module.exports = __webpack_public_path__ + "img/data_ni.32eedc81.jpg";